import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

// material-ui
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import LockOutlined from '@ant-design/icons/LockOutlined';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import ContainerOutlined from '@ant-design/icons/ContainerOutlined';

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

export default function SettingTab() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (event: React.MouseEvent<HTMLDivElement>, index: number, route: string = '') => {
    setSelectedIndex(index);

    if (route && route !== '') {
      navigate(route);
    }
  };

  useEffect(() => {
    const pathToIndex: { [key: string]: number } = {
      '/apps/profiles/account/personal': 1,
      '/apps/profiles/account/security': 2,
      '/apps/profiles/account/business': 3,
      '/apps/profiles/account/team': 4,
      '/apps/profiles/account/ui': 5
    };

    setSelectedIndex(pathToIndex[location.pathname] ?? undefined);
  }, [location.pathname]);

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton
        selected={selectedIndex === 1}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1, '/apps/profiles/account/personal')}
      >
        <ListItemIcon>
          <FileTextOutlined />
        </ListItemIcon>
        <ListItemText primary="Személyes beállítások" />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 2}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 2, '/apps/profiles/account/security')}
      >
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText primary="Biztonsági beállítások" />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 3}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 3, '/apps/profiles/account/business')}
      >
        <ListItemIcon>
          <ContainerOutlined />
        </ListItemIcon>
        <ListItemText primary="Vállalkozói beállítások" />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 4}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 4, '/apps/profiles/account/team')}
      >
        <ListItemIcon>
          <TeamOutlined />
        </ListItemIcon>
        <ListItemText primary="Csapat kezelés" />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 5}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 5, '/apps/profiles/account/ui')}
      >
        <ListItemIcon>
          <UnorderedListOutlined />
        </ListItemIcon>
        <ListItemText primary="Felületi beállítások" />
      </ListItemButton>
      {/*<Link underline="none" sx={{ color: 'inherit' }} target="_blank" href="#">*/}
      <ListItemButton
        selected={selectedIndex === 6}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 0, '')}
      >
        <ListItemIcon>
          <QuestionCircleOutlined />
        </ListItemIcon>
        <ListItemText primary="Segítség" />
      </ListItemButton>
      {/*</Link>*/}
    </List>
  );
}
